import {
  DEP_ONLINE_SET_LOADING,
  DepOnlineState,
  DepOnlineTypes,
} from './DepOnline.types';

const defaultState = {
  loading: false,
};

export function depOnlineReducer(
  state = defaultState,
  action: DepOnlineTypes,
): DepOnlineState {
  switch (action.type) {
    case DEP_ONLINE_SET_LOADING: {
      return {
        ...state,
        loading: action.loading,
      };
    }
    default:
      return state;
  }
}
